<div ng-controller="AuthenticationController as authenticationCtrl">
    <c-auto-form config="authenticationCtrl.autoFormConfig"></c-auto-form>
</div>